export default {
  styleOverrides: {
    root: {
      borderBottom: 'hidden',
    },
  },
};
